import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    injectCsrf: { type: Boolean, default: false }
  }

  connect() {
    this.element.style.display = "none";

    if (this.injectCsrfValue) {
      this.injectCSRFToken()
    }

    setTimeout(() => {
      this.element.click()
    }, 100)
  }

  injectCSRFToken() {
    const form = this.element.closest("form")
    if (form) {
      const token = document.querySelector("meta[name=\"csrf-token\"]")?.content
      if (token) {
        const input = form.querySelector("input[name=\"authenticity_token\"]") || document.createElement("input")
        input.type = "hidden"
        input.name = "authenticity_token"
        input.value = token
        if (!form.contains(input)) {
          form.appendChild(input)
        }
      }
    }
  }
}
